import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="Folder-sparkle, plus"><path d="M11.25 19.25H21.25V6.75H12L10 3.75H2.75V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.4 13H4.6L3.6 15.6L1 16.6V17.4L3.6 18.4L4.6 21H5.4L6.4 18.4L9 17.4V16.6L6.4 15.6L5.4 13Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFolderSparkle;
